/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
// import { useEnvStore } from '../env';
import { useSchedulesStore } from '.';


function useSchedules (p) {
    // const env = useEnvStore();
    const schedulesStore = useSchedulesStore();

    const [schedules, setSchedules] = useState(schedulesStore.schedules);
    const [categories, setCategories] = useState(schedulesStore.categories);
    const [categoryValue, setCategoryValue] = useState(schedulesStore.categoryValue);
    const [byCategories, setByCategories] = useState(false);
    const [scheduleCount] = useState(0);
 
    useEffect(() => {
        setByCategories(schedulesStore.byCategories);
        setCategories(schedulesStore.categories);
        setSchedules(schedulesStore.schedules);
    }, [schedulesStore.observed.schedules]);

    useEffect(() => {
        setCategoryValue(schedulesStore.categoryValue);
    }, [schedulesStore.observed.categoryValue]);

    function selectSchedulesByCategory (category) {
        if (schedulesStore.categoryFromPath) {
            schedulesStore.selectSchedulesByCategoryData(category);
        } else {
            schedulesStore.selectSchedulesByCategory(category);
        }
    }

    return {
        schedules,
        categories,
        byCategories,
        scheduleCount,
        selectSchedulesByCategory,
        categoryValue,
    };
}

export default useSchedules;